module.exports = __webpack_public_path__ + "img/54b9985.webp";